var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "mt-popup",
    {
      staticClass: "takeCardsWrapper",
      attrs: { closeOnClickModal: false, "pop-transition": "popup-fade" },
      model: {
        value: _vm.visible,
        callback: function($$v) {
          _vm.visible = $$v
        },
        expression: "visible"
      }
    },
    [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c("gift-icon"),
          _vm._v(" "),
          _c("span", { staticStyle: { "font-size": "0.35rem" } }, [
            _vm._v("今日福利")
          ]),
          _vm._v(" "),
          _c("span", [_vm._v("下单立减")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _vm._l(_vm.takeCardsArr, function(activity) {
            return _vm._l(activity.cards, function(card, index) {
              return _c("take-card-item", {
                key: card.id,
                attrs: { card: card }
              })
            })
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "footer" },
        [
          _c(
            "mt-button",
            {
              attrs: {
                type: "danger",
                size: "large",
                disabled: _vm.submitting
              },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.takeCards($event)
                }
              }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.submitting ? "正在领取..." : "立即领取") +
                  "\n    "
              )
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14792755", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14792755","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/TakeCardsModal.vue
// module id = 2GNu
// module chunks = 15